import React from "react";
import ReactDOM from "react-dom";
import App from "./components/App";
// function generateCodeFromObject(obj){
//     //return a code generated string
    
//    }
   
// module.exports=generateCodeFromObject;


 ReactDOM.render(<App />, document.getElementById("root"));